import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { get } from 'lodash'

export const generateTableColumns = ({ columnsData = [], readOnly = false }) => {
  const column = columnsData.map(columnData => {
    return {
      Header() {
        return (
          <div
            style={{
              textAlign: 'left',
              textIndent: 10,
            }}
          >
            {columnData.columnName} <FontAwesomeIcon icon="sort" size="sm" />
          </div>
        )
      },
      accessor: columnData.accessor,

      Cell(row) {
        const { value } = row
        return (
          <div
            onClick={readOnly ? () => {} : () => columnData.handleRowClick(row.original)}
            role={readOnly ? 'none' : 'button'}
            aria-hidden="true"
          >
            <p
              style={{ marginLeft: '10px', cursor: readOnly ? 'default' : 'cursor' }}
              className="cursor"
            >
              {columnData.formatter ? columnData.formatter(value) : value}
            </p>
          </div>
        )
      },
    }
  })

  return column
}

export const renderOptions = ({ optionValues = [], nameKey = 'name', idKey = 'id' }) => {
  return optionValues.map((optionValue, index) => {
    const optionKey = `${get(optionValue, nameKey) || ''}-${index}`
    return (
      <option value={get(optionValue, idKey) || index} key={optionKey}>
        {`${get(optionValue, nameKey) || ''}`}
      </option>
    )
  })
}
